import React, { createContext, useCallback, useEffect } from "react";
import { noop } from "@catchoftheday/utilities";
import { useCustomerQuery } from "../../generated/graphql";
import { jsx as ___EmotionJSX } from "@emotion/react";
export var customerInitialState = null;
export var defaultCustomerValue = {
  data: customerInitialState,
  loggedIn: false,
  loading: false,
  refetchCustomer: noop,
  logIn: noop
};
export var CustomerContext = /*#__PURE__*/createContext(defaultCustomerValue);
export var CustomerContextProvider = function CustomerContextProvider(_ref) {
  var children = _ref.children;

  var _useCustomerQuery = useCustomerQuery({
    ssr: false
  }),
      data = _useCustomerQuery.data,
      loading = _useCustomerQuery.loading,
      refetch = _useCustomerQuery.refetch;

  var customerData = !(data !== null && data !== void 0 && data.customer) ? customerInitialState : data.customer;
  var logIn = useCallback(function (_ref2) {
    var _redirectDestination = _ref2.redirectDestination,
        returnToSelf = _ref2.returnToSelf;

    if (true) {
      var returnTo = _redirectDestination || (returnToSelf && true ? window.location.pathname : undefined);
      window.location.assign("/login".concat(returnTo ? "?returnTo=".concat(returnTo) : ""));
    }
  }, []);
  useEffect(function () {
    var mounted = true;

    if (mounted) {
      refetch();
    }

    return function () {
      mounted = false;
    };
  }, [refetch]);
  return ___EmotionJSX(CustomerContext.Provider, {
    value: {
      data: customerData,
      loggedIn: !!(data !== null && data !== void 0 && data.customer),
      loading: loading,
      refetchCustomer: refetch,
      logIn: logIn
    }
  }, children);
};